import React, { useEffect, useState } from "react";
import zohoLogo from "../../images/zoho_logo.png";
import expertDefaultImg from "../../images/expert-default.png";
import AvailabilityDate from "./AvailabilityDate";
import AvailabilityComment from "./AvailabilityComment";
import AddToProject from "../ExpertDetails/AddToProject";
import EditProfileBasic from "./EditProfileBasic";

export default function TopConsultantRow({
  topCon,
  projects,
  backupData,
  setBackupData,
}) {
  const [exSummary, setExSummary] = useState(null);
  const [exExperience, setExExperience] = useState(null);
  const [availabilityComment, setAvailabilityComment] = useState(null);
  const [availablityDate, setAvailablityDate] = useState(null);
  const [availabiltyBorder, setAvailabiltyBorder] = useState("");
  const [showComment, setShowComment] = useState(false);
  const [exObject, setExObject] = useState({
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });

  const updateProfileData = (exObject) => {
    setExObject(exObject);
  };

  useEffect(() => {
    if (topCon) {
      setExSummary(topCon.summary);
      setExExperience(topCon.experience);
      setAvailabilityComment(topCon.available_comment);
      setAvailablityDate(topCon.available_from);
      setExObject({
        expertName: topCon.name,
        expertLink: topCon.link,
        expertEmail: topCon.email,
      });
    }
  }, [topCon]);

  useEffect(() => {
    if (topCon.experience) {
      let exp = topCon.experience;
      if (exp.startsWith("\r\n")) {
        exp = exp.substring(2);
        setExExperience(exp);
      }
    }
  }, [topCon.experience]);

  useEffect(() => {
    if (availablityDate) {
      const today = new Date();
      const availDate = new Date(availablityDate);
      if (
        availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" ||
        availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT"
      ) {
        setAvailabiltyBorder("");
      } else if (availDate < today) {
        setAvailabiltyBorder("topCon-img-green");
      } else if (availDate > today) {
        setAvailabiltyBorder("topCon-img-red");
      }
    }
  }, [availablityDate]);

  return (
    <div className="topCon-table-row">
      <div className="topCon-row-top">
        <ul className="list-unstyled form-inline">
          <li className="topCon-name-section">
            <a
              href={`/app/ExpertDetails/${topCon.id}`}
              className="topCon-eph-profile"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={`topCon-img ${availabiltyBorder}`}
                alt=""
                src={
                  topCon.profile_picture
                    ? topCon.profile_picture
                    : expertDefaultImg
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = expertDefaultImg;
                }}
              />
            </a>
            <a
              href={exObject.expertLink}
              className="topCon-name-tag"
              target="_blank"
              rel="noopener noreferrer"
            >
              {exObject.expertName}
            </a>
          </li>
          <li className="topCon-location-section">
            <span className="topCon-location-tag">{topCon.location}</span>
          </li>
          <li className="topCon-available-comment">
            {showComment && (
              <AvailabilityComment
                comment={availabilityComment}
                expert_id={topCon.id}
                setAvailabilityComment={setAvailabilityComment}
                backupData={backupData}
                setBackupData={setBackupData}
                setShowComment={setShowComment}
              />
            )}
          </li>
          <li className="topCon-summary">
            <div title="Summary">{exSummary}</div>
          </li>
          <li className="topCon-experience">
            <div title="Experience">{exExperience}</div>
          </li>
          <AddToProject
            expertID={topCon?.id}
            btnName={" Project"}
            allProjects={projects}
          />
        </ul>
      </div>
      <div className="topCon-row-bottom">
        <ul className="list-unstyled form-inline" style={{ marginBottom: 0 }}>
          <li className="topCon-email-section">
            <div className="topCon-email">
              <i className="fa-regular fa-envelope" />
              <span>{exObject.expertEmail}</span>
              <EditProfileBasic
                expert_id={topCon?.id}
                expert_Name={topCon?.name}
                expert_link={topCon?.link}
                expert_email={topCon?.email}
                updateProfileData={updateProfileData}
                backupData={backupData}
                setBackupData={setBackupData}
              />
            </div>
          </li>
          <li className="topCon-available-date">
            <i className="calender-icon fa-regular fa-calendar-days"></i>
            <label>Availability</label>
            <i
              className={
                availabilityComment
                  ? "comment-icon fa-regular fa-comment-dots"
                  : "comment-icon comment-empty fa-regular fa-comment-dots"
              }
              onClick={() => setShowComment(!showComment)}
              title="Click to see comment"
            ></i>
            <AvailabilityDate
              date={topCon.available_from}
              expertID={topCon.id}
              setAvailablityDate={setAvailablityDate}
              backupData={backupData}
              setBackupData={setBackupData}
            />
          </li>

          <li className="topCon-empty-class"></li>
          <li className="topCon-exLogo-section">
            {topCon.logo1 ? <img src={topCon.logo1} alt="" /> : null}
            {topCon.logo2 ? <img src={topCon.logo2} alt="" /> : null}
            {topCon.logo3 ? <img src={topCon.logo3} alt="" /> : null}
            {topCon.logo4 ? <img src={topCon.logo4} alt="" /> : null}
            {topCon.logo5 ? <img src={topCon.logo5} alt="" /> : null}
          </li>
        </ul>
        {topCon.in_zoho === "yes" && (
          <div className="topCon-inZoho">
            <img src={zohoLogo} alt="in_zoho" title="In Zoho" />
          </div>
        )}
      </div>
    </div>
  );
}
